import React, { useCallback } from 'react';
import VcardField from '@piconetworks/pkg-field-vcard';

var VcardPreview = function VcardPreview(_ref) {
  var _ref$children = _ref.children,
    children = _ref$children === void 0 ? null : _ref$children;
  var onClick = useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  return /*#__PURE__*/React.createElement(VcardField, {
    onClick: onClick
  }, children);
};

export { VcardPreview as default };
//# sourceMappingURL=index.js.map
